import React, { useLayoutEffect } from 'react';
import { bool, func, number } from 'prop-types';
import { connect } from 'react-redux';
import PageMessageService from 'mangools-commons/dist/services/PageMessageService';

import AnnouncementMessage from 'components/messages/topLevel/AnnouncementMessage';
import NewUserMessage from 'components/messages/topLevel/NewUserMessage';

import { closeTopLevelAnnouncementMessage } from 'actions/uiActions';

import {
    campaignBannerSelector,
    newUserMessageVisibilitySelector,
    timerLimitSecondsSelector,
    userPlanTypeSelector,
} from 'selectors/userSelectors';

import { announcementMesageVisibilitySelector, announcementsMessageDataSelector } from 'selectors/dataSelectors';

import AnnouncementType from 'types/AnnouncementType';
import CampaignBannerType from 'types/CampaignBannerType';

/**
 * Top Level messages and notifications wrapper.
 * Can be used for cookie info, notifications, etc.
 */
function TopLevelMessageContainer(props) {
    useLayoutEffect(() => PageMessageService.trackHeight());

    return (
        <div>
            <AnnouncementMessage
                btnText={props.announcementMesageData.btnText}
                icon={props.announcementMesageData.icon}
                messageText={props.announcementMesageData.messageText}
                newTab={props.announcementMesageData.newTab}
                onClose={props.onCloseAnnouncementMessage}
                url={props.announcementMesageData.url}
                visible={props.announcementMesageVisible}
            />
            <NewUserMessage
                campaignBanner={props.campaignBanner}
                visible={props.newUserVisible}
                timerLimitSeconds={props.timerLimitSeconds}
            />
        </div>
    );
}

const mapDispatchToProps = (dispatch, _ownProps) => ({
    onCloseAnnouncementMessage() {
        dispatch(closeTopLevelAnnouncementMessage());
    },
});

const mapStateToProps = (state, _ownProps) => ({
    announcementMesageData: announcementsMessageDataSelector(state),
    announcementMesageVisible: announcementMesageVisibilitySelector(state),
    campaignBanner: campaignBannerSelector(state),
    newUserVisible: newUserMessageVisibilitySelector(state),
    timerLimitSeconds: timerLimitSecondsSelector(state),
    userPlanType: userPlanTypeSelector(state),
});

TopLevelMessageContainer.propTypes = {
    announcementMesageData: AnnouncementType.isRequired,
    announcementMesageVisible: bool.isRequired,
    campaignBanner: CampaignBannerType,
    newUserVisible: bool.isRequired,
    onCloseAnnouncementMessage: func.isRequired,
    timerLimitSeconds: number.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopLevelMessageContainer);
